(function (Drupal) {
    Drupal.behaviors.ctaShare = {
      attach: function (context, settings) {
        const deviceDetect = {
          breakpointMobile: 768,
          isMobile: () => {
            return window.matchMedia(`(max-width: ${deviceDetect.breakpointMobile}px)`).matches;
          },
        };

        if (document.body.classList.contains('node--type-article') && deviceDetect.isMobile()) {
          
          const addToAnyBlock = document.querySelector('.addtoany_list', context);
          const imageField = document.querySelector('.field--name-field-image', context);
          if (addToAnyBlock && imageField) {
            imageField.parentNode.insertBefore(addToAnyBlock, imageField.nextSibling);
          }
        }
        if(document.body.classList.contains('node--type-investigation-education')) {
          
          const viewdate = document.querySelector('.view-date ', context);
          const containerHeader = document.querySelector('.node--type-investigation-education .container-header', context);

          if (viewdate && containerHeader) {

            containerHeader.appendChild(viewdate);
            //viewdate.remove()
          }
        }
        if(document.body.classList.contains('node--type-article')) {
          console.log(".....");
          
          const viewdate = document.querySelector('.view-date ', context);
          const containerHeader = document.querySelector('.node--type-article .container-header', context);

          if (viewdate && containerHeader) {

            containerHeader.appendChild(viewdate);
            //viewdate.remove()
          }
        }
      }
    };
  })(Drupal);
  